import { Trade } from '../types';

export interface ConditionStats {
  label: string;
  total: number;
  wins: number;
  losses: number;
  breakevens: number;
  winRate: number;
}

type Filter = (t: Trade) => boolean;

function computeStat(label: string, trades: Trade[], filter: Filter): ConditionStats {
  const filtered = trades.filter(filter);
  const wins = filtered.filter(t => t.result === 'win').length;
  const losses = filtered.filter(t => t.result === 'loss').length;
  const breakevens = filtered.filter(t => t.result === 'be').length;
  const total = filtered.length;
  const winRate = total > 0 ? Math.round((wins / total) * 100) : 0;
  return { label, total, wins, losses, breakevens, winRate };
}

export function computeConditionStats(trades: Trade[]): ConditionStats[] {
  return [
    computeStat('전체', trades, () => true),
    computeStat('롱 진입', trades, t => t.side === 'long'),
    computeStat('숏 진입', trades, t => t.side === 'short'),
    computeStat('펀딩 양수 (>0%)', trades, t => t.funding > 0),
    computeStat('펀딩 음수 (<0%)', trades, t => t.funding < 0),
    computeStat('펀딩 고점 (>0.03%)', trades, t => t.funding > 0.03),
    computeStat('펀딩 저점 (<-0.03%)', trades, t => t.funding < -0.03),
    computeStat('OI 증가', trades, t => t.oiTrend === 'up'),
    computeStat('OI 감소', trades, t => t.oiTrend === 'down'),
    computeStat('Liq 증가', trades, t => t.liqTrend === 'up'),
    computeStat('Liq 감소', trades, t => t.liqTrend === 'down'),
    computeStat('BTC', trades, t => t.symbol === 'BTC'),
    computeStat('ETH', trades, t => t.symbol === 'ETH'),
  ];
}
